import { useCore } from '@/data/core';
import { formatTime } from '@/lib/formats';
import { format, isSameMonth, isSameYear, isToday, isYesterday } from 'date-fns';
import type { Range, Scope } from '@/data/stats';

/** "Monday, 15 September" · "Mon 15 – Sun 21 Sep" · "September 2026" */
export function rangeTitle(scope: Scope, { from, to }: Range): string {
  if (scope === 'today') return isToday(from) ? `Today · ${format(from, 'EEEE d MMMM')}` : isYesterday(from) ? `Yesterday · ${format(from, 'EEEE d MMMM')}` : format(from, 'EEEE, d MMMM yyyy');
  if (scope === 'month') return format(from, isSameYear(from, new Date()) ? 'MMMM' : 'MMMM yyyy');
  const last = new Date(to.getTime() - 1);
  return isSameMonth(from, last) ? `${format(from, 'EEE d')} – ${format(last, 'EEE d MMM')}` : `${format(from, 'EEE d MMM')} – ${format(last, 'EEE d MMM')}`;
}

export const dayHeading = (d: Date) => (isToday(d) ? 'Today' : isYesterday(d) ? 'Yesterday' : format(d, 'EEEE d MMMM'));
/** A clock time in the person's chosen format. Reads the store directly so list helpers can call it; the setting only changes on the Appearance screen, which shows no times, so nothing on screen goes stale. */
export const timeHM = (iso: string) => formatTime(new Date(iso), useCore.getState().settings.timeFormat);
